import React, { useEffect, useState } from "react";
import { Volume2, VolumeX } from "lucide-react";
import { isMuted, setMuted, unlockAudio, dingDong } from "@/lib/audioAlerts";

const SoundToggle = ({ testid = "sound-toggle" }) => {
    const [muted, setLocalMuted] = useState(isMuted());

    useEffect(() => {
        const onChange = () => setLocalMuted(isMuted());
        window.addEventListener("smarttable-sound-changed", onChange);
        return () => window.removeEventListener("smarttable-sound-changed", onChange);
    }, []);

    const toggle = () => {
        const next = !muted;
        setMuted(next);
        setLocalMuted(next);
        if (!next) {
            // Just unmuted: unlock context + play a short confirmation
            unlockAudio();
            dingDong();
        }
    };

    return (
        <button
            onClick={toggle}
            data-testid={testid}
            title={muted ? "Suoni disattivati — clicca per attivare" : "Suoni attivi — clicca per disattivare"}
            className={`h-10 px-3 rounded-md border flex items-center gap-2 text-xs uppercase tracking-wider transition-colors ${
                muted
                    ? "border-red-700/50 bg-red-900/20 text-red-300 hover:border-red-500"
                    : "border-brand bg-brand-soft text-brand hover:bg-brand/20"
            }`}
        >
            {muted ? <VolumeX className="w-4 h-4" /> : <Volume2 className="w-4 h-4" />}
            <span>{muted ? "Suoni OFF" : "Suoni ON"}</span>
        </button>
    );
};

export default SoundToggle;
